import React from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalTitle, ModalFooter, ModalBody } from "@vds/modals";
import { useNavigate } from "react-router-dom";
import { clear4g5gCart } from "pages/Qualification/ducks/QualificationSlice";
import { useDispatch } from "react-redux";
import {
  setIsPOYDFlow,
  setIsPOYDFromGridwall
} from "pages/Mobility/ducks/MobilitySlice";

const POYDMaxDeviceModal = ({
  opened,
  onOpenedChange,
  ...props
}) => {
  const { t } = useTranslation(["pdp"]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <Modal
      hideCloseButton={false}
      opened={opened}
      onOpenedChange={onOpenedChange}
      disableFocusLock= {true}
    >
      <ModalTitle>{t("device-pdp.poydMaxDeviceModal.title", { ns: "pdp" })}</ModalTitle>
      <ModalBody>{t("device-pdp.poydMaxDeviceModal.subtext", { ns: "pdp" })}</ModalBody>
      <ModalFooter
        buttonData={{
          primary: {
            width: "100%",
            children: t("device-pdp.poydMaxDeviceModal.CTA", { ns: "pdp" }),
            onClick: () => {
              onOpenedChange(false);
              dispatch(setIsPOYDFlow(false));
              dispatch(setIsPOYDFromGridwall(false));
              dispatch(clear4g5gCart());
            },
          },
          close: {
              children: t("device-pdp.poydMaxDeviceModal.cancelCTA", { ns: "pdp" }),
              onClick: () => { onOpenedChange(false) },
          },
        }}
      />
    </Modal>
  );
};

export default POYDMaxDeviceModal;
